import React, { forwardRef } from "react";
import { string, node, oneOfType, arrayOf, func, oneOf, bool } from "prop-types";
import cx from "classnames";
import { camel } from "case";
// eslint-disable-next-line import/no-cycle
import { Button as ButtonComponent } from "../../sharedComponents/Button";
import * as styles from "./Button.module.scss";

const Button = forwardRef(
	(
		{
			id,
			children,
			label,
			className,
			to,
			onClick,
			onMouseEnter,
			target,
			showExternalIcon,
			icon,
			iconPlacement,
			type,
			theme,
			size,
			outline,
			disabled,
			full,
			asText,
			noStyle,
			ariaControls,
			ariaExpanded,
		},
		ref
	) => {
		const classes = cx({
			[styles[camel(theme)]]: theme && styles[camel(theme)],
			[styles.outline]: outline,
			[styles.asText]: asText,
			[className]: className,
		});
		const noStyleClasses = cx({
			[className]: className,
		});
		return (
			<ButtonComponent
				id={id}
				type={type}
				className={noStyle ? noStyleClasses : classes}
				to={to}
				target={target}
				size={size}
				disabled={disabled}
				theme={false}
				asText={false}
				outline={outline}
				onClick={onClick}
				onMouseEnter={onMouseEnter}
				icon={icon}
				full={full}
				noStyle={noStyle}
				showExternalIcon={showExternalIcon}
				iconPlacement={iconPlacement}
				label={children || label}
				ref={ref}
				ariaControls={ariaControls}
				ariaExpanded={ariaExpanded}
			/>
		);
	}
);

Button.propTypes = {
	showExternalIcon: bool,
	icon: string,
	iconPlacement: oneOf(["right", "left"]),
	children: oneOfType([arrayOf(node), node]),
	className: string,
	to: string,
	target: oneOf(["_self", "_blank", "_top", "_parent"]),
	onClick: func,
	onMouseEnter: func,
	theme: oneOf(["primary", "wedding", "booking-path", "primary-invert"]),
	type: string,
	outline: bool,
	label: string,
	size: oneOf(["sm", "md", "lg", "xl", "auto"]),
	disabled: bool,
	full: bool,
	asText: bool,
	noStyle: bool,
	id: string,
	ariaControls: string,
	ariaExpanded: bool,
};
Button.defaultProps = {
	showExternalIcon: false,
	icon: undefined,
	iconPlacement: undefined,
	children: undefined,
	label: "",
	className: "",
	to: undefined,
	onClick: undefined,
	onMouseEnter: undefined,
	target: "_self",
	theme: "primary",
	type: "button",
	outline: false,
	size: "md",
	disabled: false,
	full: false,
	asText: false,
	noStyle: false,
	id: undefined,
	ariaControls: undefined,
	ariaExpanded: undefined,
};

export default Button;
export { Button };
